import { render, staticRenderFns } from "./TabHistory.vue?vue&type=template&id=07a04d8c&scoped=true&"
import script from "./TabHistory.vue?vue&type=script&lang=js&"
export * from "./TabHistory.vue?vue&type=script&lang=js&"
import style0 from "./TabHistory.vue?vue&type=style&index=0&id=07a04d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a04d8c",
  null
  
)

export default component.exports